var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaB582(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.348,
    height: 79.634,
    viewBox: "0 0 70.348 79.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34352",
    "data-name": "Group 34352",
    transform: "translate(-6832.646 -2185.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32429",
    "data-name": "Group 32429",
    transform: "translate(6834.396 2187.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32428",
    "data-name": "Group 32428",
    transform: "translate(6.336 4.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26401",
    "data-name": "Path 26401",
    d: "M6894.09,2204.947h4.63a5.652,5.652,0,0,1,5.652,5.653v51.668a5.652,5.652,0,0,1-5.652,5.652h-42.64a5.652,5.652,0,0,1-5.652-5.652V2210.6a5.652,5.652,0,0,1,5.652-5.653h4.373",
    transform: "translate(-6850.429 -2202.287)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26402",
    "data-name": "Path 26402",
    d: "M6888.953,2198.216l2.956,6.6h17.586l2.956-6.6",
    transform: "translate(-6873.729 -2198.216)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26403",
    "data-name": "Path 26403",
    d: "M6955.893,2293.942",
    transform: "translate(-6914.217 -2256.115)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26404",
    "data-name": "Path 26404",
    d: "M6901.243,2240.5v12.3a11.078,11.078,0,0,1-11.078,11.078h-44.692A11.077,11.077,0,0,1,6834.4,2252.8v-53.978a11.078,11.078,0,0,1,11.078-11.078h44.692a11.078,11.078,0,0,1,11.078,11.078Z",
    transform: "translate(-6834.396 -2187.749)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32430",
    "data-name": "Group 32430",
    transform: "translate(6850.891 2206.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26405",
    "data-name": "Path 26405",
    d: "M6876.139,2235.31h13.688a7.8,7.8,0,0,1,7.8,7.8h0a7.8,7.8,0,0,1-7.8,7.8h-13.688",
    transform: "translate(-6876.139 -2235.31)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    y2: 31.685,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x2: 23.497,
    y2: 23.497,
    transform: "translate(8.709 15.842)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    y1: 20.794,
    x2: 20.794,
    transform: "translate(11.378 18.546)",
    fill: "none",
    stroke: "#86b8ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaB582);
export default __webpack_public_path__ + "static/media/hla-b-58-2.1a0ccc3cb0ca8250554f2a11a7e8e762.svg";
export { ForwardRef as ReactComponent };